import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { WebinarScheduleComponent } from './webinar-schedule.component';

@NgModule({
  exports: [WebinarScheduleComponent],
  imports: [CommonModule, FontAwesomeModule, WebinarScheduleComponent],
})
export class WebinarScheduleModule {}
